(function(){

    angular.module('tmx-app').controller('deviceManagementCtrl', ['$scope', '$mdDialog', '$state','DeviceService','$mdSidenav',
        'resolvedData','TmxDialogService','CurrentUserService','tmxUtility','menu', 
    
        function DeviceManagementCtrl($scope, $mdDialog, $state, DeviceService, $mdSidenav, resolvedData,TmxDialogService,
            CurrentUserService,tmxUtility,menu){
  
            var deviceVM=this;
            var exists;
            var copy;
            deviceVM.EntityName = "DeviceManagement";
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
    ///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            deviceVM.menu = menu;
            deviceVM.Privileges = [];
            deviceVM.ViewPrivilege = false;
            deviceVM.EditPrivilege = false;
            deviceVM.DeletePrivilege = false;
            deviceVM.AddPrivilege = false;
            deviceVM.checkPermission = tmxUtility.checkPermission;                               


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            deviceVM.query = "Device";
            deviceVM.gridData = new kendo.data.ObservableArray([]);
            deviceVM.date = new Date().toJSON();
            var arr = deviceVM.date.split("T");
            var arr2 = arr[1].split(":");
            arr2[0] = (Number(arr2[0]) + 5).toString();
            deviceVM.date = arr[0] + "T" + arr2[0] + ":" + arr2[1] + ":" + arr2[2];
            deviceVM.cols = DeviceService.gridColumn;
            deviceVM.cols[1].data = resolvedData.Users.data;
            deviceVM.nav = "SearchSideNav";
            deviceVM.schema = DeviceService.schema;
            deviceVM.cloneColumn = DeviceService.gridColumn;
            deviceVM.users = resolvedData.Users;
            deviceVM.DeviceService = DeviceService;
  

  //**********functions****************
            deviceVM.reload=function(){
                deviceVM.container.deviceGrid.dataSource.read();
            }
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            deviceVM.checkAddDisabled = function(){
                if($mdSidenav(deviceVM.nav).isOpen()){
                    return true;
                }
                else{
                    return false;
                }
            };
            deviceVM.success=function(promise){
                if(promise.read==true) {
      //deviceVM.container.deviceGrid.dataSource.transport.read(promise);
                    for (var j = deviceVM.container.deviceGrid.columns.length - 1; j >= 0; j--) {
        
      
                        if(angular.isDefined(deviceVM.o.data.filter) && deviceVM.o.data.filter!=null) {
                            if(angular.isDefined(deviceVM.o.data.filter.filters) && deviceVM.o.data.filter.filters.length>0) {
                                for (var i = deviceVM.o.data.filter.filters.length - 1; i >= 0; i--) {
                                    if(deviceVM.o.data.filter.filters[i].field==deviceVM.container.deviceGrid.columns[j].field) {
                                        deviceVM.container.deviceGrid.columns[j].headerTemplate="<span>"+deviceVM.container.deviceGrid.columns[j].title+"<md-icon >file_download</md-icon></span>";
                                        deviceVM.container.deviceGrid.columns[j].title="changed";
                                    }
                                }
                            }
                        } 
                    }
                }
                else {
                    deviceVM.container.deviceGrid.dataSource.read(); 
                }
    //deviceVM.toggleSearch(deviceVM.nav);
            };
            deviceVM.currentTenant= CurrentUserService.getUserObject();
            deviceVM.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            }  

            deviceVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };

            deviceVM.new = function(){
    //deviceVM.searchClear = true;
                $state.go($state.current.name+".add");
            };

            deviceVM.clickEdit = function (item) {  
    //deviceVM.searchClear = true;
                $state.data.info = false;          
                $state.go($state.current.name+".edit",{"Id":item.DeviceID});
            };

  // $state.data.info = false;

            deviceVM.clickView = function (item) {   
    //deviceVM.searchClear = true;
                $state.data.info = true;         
                $state.go($state.current.name+".edit",{"Id":item.DeviceID});
            }; 

            deviceVM.clickActive = function (item) {   
                var confirm = $mdDialog.confirm()
                    .title('Activate Device '+item.DeviceName+" ?")
                    .textContent('Are you sure you want to activate this device?')
                    .ariaLabel('Lucky day')
                    .clickOutsideToClose(true)
              // .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function() {
                    item.$activate(item.DeviceId).then(function() {
                        deviceVM.container.deviceGrid.dataSource.read();
                    });
                }, function() {

                });
            
            };

            deviceVM.clickInactive = function (item) {   
 
                var diagConfig={
                    action:"Deactivate",
                    entity:"Device",
                    entityname:item.DeviceName,
                    details:[
                        {value:item.DeviceName,label:"Device Name"},
                        {value:deviceVM.formatPhoneNumber(item), label:"Phone Number"},
                        {value:deviceVM.formatManufacturer(item), label:"Manufacturer"}
                    ],
                    options:[
                        {label:"Deactivate",value:true,class:"md-warn"},
                        {label:"Cancel",value:false,class:"md-primary"}
                    ]
                };
                function callback(ok) {
                    if(ok){
                        deviceVM.Deactivate(item);
                    }
                }
                var deviceDeactivateDialog=new TmxDialogService.confirmDialog(diagConfig,callback);

                deviceDeactivateDialog.show();
            }
            deviceVM.Deactivate = function(item) {
                item.$deactivate(item.DeviceId).then(function() {
                    deviceVM.container.deviceGrid.dataSource.read();
                });
            };

//*************for cloning devices**************** 
//************not using it but kept for future reference***********
  // deviceVM.clone = 0;

  // deviceVM.clickCopy = function () {            
  //      $mdDialog.show({
  //           clickOutsideToClose: true,
  //           controller: function ($mdDialog) {
  //               var vm = this;
  //               vm.clone = deviceVM.clone;
  //               // vm.task = task;  //your task object from the ng-repeat

  //               $scope.hide = function () {
  //                   $mdDialog.hide();
  //               };
  //               $scope.cancel = function () {
  //                   $mdDialog.cancel();
  //               };
  //           },
  //           controllerAs: 'modal',
  //           templateUrl: 'app/private/clone.html',
  //           parent: angular.element(document.body),
  //           targetEvent: e
  //       });
  //       }
//*******************************************

 
            deviceVM.dataObj ={
                value: "empty"
            };

  
   //**********kendo row template functions************


            deviceVM.clickDelete = function () {            
                //deleteConfirm(item);
            }
// grey out the row if returned true
            deviceVM.isStatusActive=function(dataitem){
                if(dataitem.Status=="Active"  ){
                    return true;
                }
                return false;
            }

            deviceVM.isEditable=function(dataitem){
                if(dataitem.Status=="Active" || dataitem.Status=="Pending" ){
                    return true;
                }
                return false;
            }

            deviceVM.formatDeviceName=function(dataitem) {

                return  tmxUtility.sliceText(dataitem.DeviceName,25);

            }

    // show activate and deactivate option
            deviceVM.notPending=function(dataitem){
                // var endDate = dataitem.EffectiveEndDate.split("T");
                // endDate = endDate[0];
                // var startDate = dataitem.EffectiveStartDate.split("T");
                // startDate = startDate[0];
                // var date = deviceVM.date.split("T");
                // date = date[0];
                if(dataitem.EffectiveStartDate>deviceVM.date) {
                    return false;
                }
                else if(dataitem.EffectiveEndDate>=deviceVM.date && dataitem.EffectiveStartDate<=deviceVM.date) {
                    if(angular.isDefined(dataitem.UserId) && dataitem.UserId!=null) {
                        return true;
                    }
                }
                return false;
            }

            deviceVM.status=function(dataitem){

                if(dataitem.Status=="Inactive") {
                    return "Inactive";
                }
                else if(dataitem.Status=="Pending") {
                    return "Pending";
                }
                else if(dataitem.Status=="Active") {
                    return "Active";

                }
  
            }
            deviceVM.isPending=function(status) {
                if(status=="Pending")return true;
                return false;
            }
            deviceVM.getUser=function(dataitem){
  
                if(dataitem.UserName!=null && angular.isDefined(dataitem.UserName!=null) && dataitem.UserName!="0") {
                    return dataitem.UserName;
                }

                return "N/A";
            }

            deviceVM.formatManufacturer=function(dataitem){
                if(dataitem.DeviceMake!=null && dataitem.DeviceModelName!=null) {
                    return dataitem.DeviceMake + " " + dataitem.DeviceModelName;
                }
                else if(dataitem.DeviceMake!=null && dataitem.DeviceModelName==null) {
                    return dataitem.DeviceMake;
                }
                else if(dataitem.DeviceMake==null && dataitem.DeviceModelName!=null) {
                    return dataitem.DeviceModelName;
                }
                else
                    return "N/A";
            }

            deviceVM.formatPhoneNumber=function(dataitem){
                if(angular.isDefined(dataitem.PhoneNumber1) && dataitem.PhoneNumber1!=null) {

                    return "+"+dataitem.PhoneNumber1;
                }
                return "N/A";
            }
            deviceVM.isFiltered=function(fieldName){
                var filtered = false;
                if(fieldName=="Status"){
                    fieldName="EffectiveEndDate";
                }
                if(fieldName=="DeviceModelName"){
                    if(angular.isDefined(deviceVM.filters)) {
                        deviceVM.filters.compositeFilter.forEach(function(filter){
                            if(filter.field==fieldName) {filtered = true;}
                            else if(filter.field=="EffectiveStartDate" && fieldName=="EffectiveEndDate") {
                                filtered = true;
                            }
                        });
                    }
                    return filtered;
                }
                else{
                    if(angular.isDefined(deviceVM.filters)) {
                        deviceVM.filters.filters.forEach(function(filter){
                            if(filter.field==fieldName) {
                                filtered = true;
                            }
                            else if(filter.field=="EffectiveStartDate" && fieldName=="EffectiveEndDate") {
                                filtered = true;
                            }
                        });
                    }
                    return filtered;
                }
            }

//***********************************************


//*******************KENDO*********************//  
            deviceVM.gridColumns = DeviceService.columns;

            deviceVM.mainGridOptions = {
                dataSource: {
            
                    transport: {
                        read: function(o){
                            if(angular.isDefined(deviceVM.searchClear) && deviceVM.searchClear==false){
                                if(exists(deviceVM.o)){
                                    copy(deviceVM.o.data,["filter"],o.data);
                                }
                            }
                            deviceVM.searchClear = false;
                            if(deviceVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    deviceVM.searchClear = true;
                                    $state.searchClear=undefined;
                           //return;
                                }
                      //if(exists(deviceVM.o))
                      //  copy(deviceVM.o.data,["filter"],o.data);
                            }
                            else
                                o.data.firstPage = true;
                            deviceVM.o = angular.copy(o);  
                            deviceVM.filters = deviceVM.o.data.filter;
                            DeviceService.getByParams(o,true).then(function(response){
                                o.success(response)
                            });
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort:  [{field: "DeviceId", dir: "desc"}]
            // sort:  [{field: "EffectiveEndDate", dir: "desc"}],
                },
        // selectable: "multiple, row",
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 4
                },

                pdf: {
                    allPages: true,
                    fileName: "Devices.pdf"
                },
                excel: {
         /* allPages: true,*/
                    fileName: "Devices.xlsx"
                },
                sortable: true,
                scrollable: false,
        // groupable: true,
        // 
                rowTemplate: "<tr data-uid='#= uid #' ><td class='k-link k-col-width'><md-button  class='tmx-primary-text' ng-disabled='!DeviceManagementCtrl.isEditable(dataItem) || !DeviceManagementCtrl.checkPermission(\"Private.Administration.DeviceManagement\",\"Edit\")' ng-click='DeviceManagementCtrl.clickEdit(dataItem)' ng-bind='DeviceManagementCtrl.formatDeviceName(dataItem)'>  <md-tooltip md-direction='top' ng-bind='dataItem.DeviceName'></md-tooltip> </md-button></td><td class='k-link k-col-width'> {{DeviceManagementCtrl.getUser(dataItem)}}   </td><td class='k-link k-col-width'> {{DeviceManagementCtrl.formatPhoneNumber(dataItem)}} </td><td class='k-link k-col-width'> {{DeviceManagementCtrl.formatManufacturer(dataItem)}} </td><td class='k-link k-col-width'> <span class=' status-{{DeviceManagementCtrl.status(dataItem)}}' >{{dataItem.Status}} </span>  </td><td class='k-link k-col-width' layout='row'><md-menu md-position-mode='target-right target' md-offset='-10 0' flex='none' class='menu-list-item' ><md-button   class='menu-list-item-grid' ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons '>more_vert</md-icon></md-button><md-menu-content width='2' ><md-menu-item><md-button ng-disabled='!DeviceManagementCtrl.checkPermission(\"Private.Administration.DeviceManagement\",\"View\")' aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>info</md-icon>Device Info</md-button></md-menu-item><md-menu-item ng-if='DeviceManagementCtrl.isStatusActive(dataItem) && !DeviceManagementCtrl.isPending(dataItem.Status)'><md-button  aria-label='del' class='tmxMin' ng-disabled='!DeviceManagementCtrl.DeletePrivilege' ng-click='DeviceManagementCtrl.clickInactive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate Device</md-button></md-menu-item><md-menu-item ng-if='!DeviceManagementCtrl.isStatusActive(dataItem) && !DeviceManagementCtrl.isPending(dataItem.Status)'><md-button  aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickActive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>check_circle</md-icon>Activate Device</md-button></md-menu-item></md-menu-content></md-menu></td></tr>",
        // rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': DeviceManagementCtrl.isStatusActive(dataItem)}\"><td><md-button class='tmx-primary-text' ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' ng-click='DeviceManagementCtrl.clickEdit(dataItem)'> #= DeviceName # </md-button></td><td> {{DeviceManagementCtrl.getUser(dataItem)}}   </td><td> {{DeviceManagementCtrl.formatPhoneNumber(dataItem)}} </td><td>#= DeviceImei # </td><td> {{DeviceManagementCtrl.formatManufacturer(dataItem)}} </td><td> {{DeviceManagementCtrl.status(dataItem)}}   </td><td><md-menu flex='none' class='menu-list-item' ><md-button  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button><md-menu-content width='2' ><md-menu-item><md-button ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Delete Device</md-button></md-menu-item><md-menu-item><md-button ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>info</md-icon>Device Info</md-button></md-menu-item><md-menu-item ng-if='!DeviceManagementCtrl.isStatusActive(dataItem)'><md-button  aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickInactive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate Device</md-button></md-menu-item><md-menu-item ng-if='DeviceManagementCtrl.isStatusActive(dataItem)'><md-button  aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickActive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>check_circle</md-icon>Activate Device</md-button></md-menu-item><md-menu-item><tmx-duplicate disable='DeviceManagementCtrl.isStatusActive(dataItem)' model='dataItem' schema='DeviceManagementCtrl.schema' columns='DeviceManagementCtrl.cloneColumn' on-submit='DeviceManagementCtrl.reload()'> </tmx-duplicate></td></md-menu-item></md-menu-content></md-menu></td></tr>",
                columns: DeviceService.columns
            };

//**********For Bulk Delete***************
//<td><input type='checkbox' class='checkbox' ng-click='DeviceManagementCtrl.onClick($event,dataItem)' /> </td>

// deviceVM.onClick = function(e,dataItem){
//           var element =$(e.currentTarget);
          
//           var checked = element.is(':checked');
//           var  row = element.closest("tr");
//           if (checked) {
//             row.addClass("k-state-selected");
//             deviceVM.addToBulk(dataItem);
//           } else {
//             row.removeClass("k-state-selected");
//             deviceVM.removeFromBulk(dataItem);
//           }
//         };

//         deviceVM.bulk = [];

//       deviceVM.addToBulk = function(dataItem) {
//         deviceVM.bulk.push(dataItem);
//       };

//       deviceVM.removeFromBulk = function(dataItem) {
//         for (var i = deviceVM.bulk.length - 1; i >= 0; i--) {
//           if (deviceVM.bulk[i].DeviceId===dataItem.DeviceId) 
//             {
//               deviceVM.bulk.splice(i,1);
//             }
//         }
      
//       };

//       deviceVM.bulkDelete =function()
//       {
        
//         var confirm = $mdDialog.confirm()
              
//               .title('Bulk Delete')
//               .textContent('Are you sure you want to delete ' + deviceVM.bulk.length +' devices?')
//               .ariaLabel('Lucky day')
//               .clickOutsideToClose(true)
//               // .targetEvent(ev)
//               .ok('Yes')
//               .cancel('Cancel');

//         $mdDialog.show(confirm).then(function() {
//           DeviceService.bulkDelete(deviceVM.bulk);
//         }, function() {

//         });
  
      // };

//*****************************************
            deviceVM.container = {};
            $state.data={
                grid: deviceVM.container,
                info: false

            };


//************for filtering/search************
            deviceVM.searchSideNavActive=false;
    
            deviceVM.toggleSearch=function(){
                if(deviceVM.searchSideNavActive) {
                    deviceVM.searchData = {};
                    deviceVM.searchSideNavActive=false;
                }
                else
                    deviceVM.searchSideNavActive=true;
                deviceVM.toggle('SearchSideNav');
            }
            deviceVM.exportSideNavActive=false;

            deviceVM.toggleExport=function(){
                if(deviceVM.exportSideNavActive)
                    deviceVM.exportSideNavActive=false;
                else
                    deviceVM.exportSideNavActive=true;
                deviceVM.toggle('ExportSideNav');
            }

            deviceVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };

            deviceVM.filt = {};
    

            deviceVM.search = function(navID) {
      
                let calls=[];
  

                for (var key in deviceVM.searchData) {
                    if (deviceVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: deviceVM.searchData[key]
                        });
                    }
                }

                deviceVM.filt = {
                    filters: calls,
                    logic: "and"
                };
                deviceVM.o.data.filter = deviceVM.filt;
                deviceVM.container.deviceGrid.dataSource.transport.read(deviceVM.o);

                deviceVM.searchData = {};
                deviceVM.toggle(navID);
            };

            deviceVM.clear = function(navID) {
                deviceVM.searchData = {};
                deviceVM.toggle(navID);
            };
        }]);

})();